import { type DocumentNode, gql } from '@apollo/client';

/**
 * Lightweight query for resolving an asset's display name and media type icon.
 * Used by PlaylistItemRow when drag data doesn't carry this info.
 */
const assetBasicInfo: DocumentNode = gql`
  query assetBasicInfo($id: ID!) {
    asset(id: $id) {
      id
      name
      mediatype
    }
  }
`;

export default assetBasicInfo;
